var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "agree" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("p", [_vm._v("更新日期：2024年07月01日")]),
    _vm._v(" "),
    _c("p", { staticClass: "item" }, [_vm._v("生效日期：2024年07月01日")]),
    _vm._v(" "),
    _c("p", [_vm._v("版本更新提示：")]),
    _vm._v(" "),
    _c("p", { staticClass: "item" }, [
      _vm._v(
        "\n      感谢您使用给缘！本次大连亿果网络科技有限公司（下称“我们”或“给缘”）依据《信息安全技术个人信息安全规范》（GB/T\n      35273-2020）以及其他相关法律法规和技术规范更新了一些内容，其中主要包括如下内容：根据法律法规和技术规范更新了部分定义；追加了我们获取您权限和相关个人信息的信息。\n    "
      )
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "item" }, [
      _vm._v(
        "\n      为了更好的保护您的个人信息，建议您仔细阅读更新后的《给缘隐私政策》。如您对本隐私政策条款有任何异议或疑问，您可通过本《给缘隐私政策》第九章节“如何联系我们”中公布的联系方式与我们沟通。\n    "
      )
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "item" }, [
      _vm._v(
        "\n      当您与我们就取得产品或服务进行联系时，将可能被要求提供部分个人信息\n    "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n      我们深知个人信息对您的重要性，也理解您关心您的个人信息是如何被使用的，因此我们制订了本《给缘隐私政策》（以下简称“隐私政策”或“政策”），以阐述我们如何收集、使用及储存您的个人信息，我们将如何保护您的个人信息安全。\n    "
      )
    ]),
    _vm._v(" "),
    _c("p", [_vm._v("我们制定本隐私政策并特别提示您：")]),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n      一旦您开始使用给缘提供的各项产品或服务，即表示您已充分理解并同意本政策。\n    "
      )
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "item" }, [
      _vm._v("本隐私政策将帮助您了解以下内容：")
    ]),
    _vm._v(" "),
    _c("p", {}, [_vm._v("第一章节 我们如何收集和使用您的个人信息")]),
    _vm._v(" "),
    _c("p", {}, [_vm._v("第二章节 我们如何储存您的个人信息")]),
    _vm._v(" "),
    _c("p", {}, [_vm._v("第三章节 我们如何共享、转让、公开披露您的个人信息")]),
    _vm._v(" "),
    _c("p", {}, [_vm._v("第四章节 我们如何保护您的个人信息")]),
    _vm._v(" "),
    _c("p", {}, [_vm._v("第五章节 我们使用Cookie技术的目的及方式")]),
    _vm._v(" "),
    _c("p", {}, [_vm._v("第六章节 您如何管理您的个人信息")]),
    _vm._v(" "),
    _c("p", {}, [_vm._v("第七章节 我们如何处理未成年人的个人信息")]),
    _vm._v(" "),
    _c("p", {}, [_vm._v("第八章节 隐私政策如何更新")]),
    _vm._v(" "),
    _c("p", { staticClass: "item" }, [_vm._v("第九章节 如何联系我们")]),
    _vm._v(" "),
    _c("p", { staticClass: "topTitle" }, [
      _vm._v("第一章节 我们如何收集和使用您的个人信息")
    ]),
    _vm._v(" "),
    _c("dl", [
      _c("dt", { staticClass: "bold" }, [_vm._v("一、个人信息范围")]),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _c("dt", { staticClass: "bold" }, [_vm._v("二、收集个人信息的业务功能")]),
      _vm._v(" "),
      _c("dd", { staticClass: "item" }, [
        _vm._v(
          "\n        我们根据合法、正当、必要的原则，为实现给缘\n        APP下述的各项功能，收集和使用您的个人信息：\n      "
        )
      ]),
      _vm._v(" "),
      _c("dd", { staticClass: "item" }, [
        _c("table", [
          _vm._m(3),
          _vm._v(" "),
          _c(
            "tbody",
            [
              _vm._m(4),
              _vm._v(" "),
              _vm._l(_vm.listData, function(item) {
                return _c("tr", { key: item.seq }, [
                  _c("td", [_vm._v(_vm._s(item.seq))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(item.effect))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(item.type))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(item.obj))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(item.mode))])
                ])
              })
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _vm._m(5),
      _vm._v(" "),
      _vm._m(6),
      _vm._v(" "),
      _c("dt", { staticClass: "bold" }, [
        _vm._v("三、与第三方账号相关的信息收集和使用")
      ]),
      _vm._v(" "),
      _vm._m(7),
      _vm._v(" "),
      _c("dt", { staticClass: "bold" }, [
        _vm._v("四、拒绝提供个人信息的选项及其可能带来的影响")
      ]),
      _vm._v(" "),
      _c("dd", [
        _vm._v(
          "\n        您可以通过给缘APP或给缘平台的网站和其他软件中的选项来设置是否向我们提供某些个人信息，具体设置方法取决于您设置时该等产品的功能与界面设计，您可以咨询我们的客服人员。举例来说，观看直播的用户可以随时通过“我的→设置→消息通知”的控制开关来打开或关闭声音/震动提示。\n      "
        )
      ]),
      _vm._v(" "),
      _vm._m(8),
      _vm._v(" "),
      _vm._m(9),
      _vm._v(" "),
      _c("dt", { staticClass: "bold" }, [_vm._v("五、您个人信息使用的规则")]),
      _vm._v(" "),
      _vm._m(10),
      _vm._v(" "),
      _c("dt", { staticClass: "topTitle" }, [
        _vm._v("第二章节 我们如何存储您的个人信息")
      ]),
      _vm._v(" "),
      _c("dd", [
        _vm._v(
          "\n        1、我们在中华人民共和国境内运营中收集和产生的您的个人信息，存储在中国境内。\n      "
        )
      ]),
      _vm._v(" "),
      _vm._m(11),
      _vm._v(" "),
      _vm._m(12),
      _vm._v(" "),
      _c("dd", { staticClass: "item" }, [
        _vm._v(
          "\n        当我们的产品或服务发生停止运营的情形时，我们将以推送通知、公告等形式通知您，并在合理的期限内删除您的个人信息或进行匿名化处理。\n      "
        )
      ]),
      _vm._v(" "),
      _c("dt", { staticClass: "bold item" }, [
        _vm._v(
          "\n        第三章节 我们如何共享、转让、公开披露您的个人信息\n      "
        )
      ]),
      _vm._v(" "),
      _c("dd", { staticClass: "item" }, [
        _vm._v(
          "\n        我们已知晓对外共享、转让、公开披露个人信息所承担的相应法律责任，我们仅会在本隐私政策约定的范围内共享、转让、公开披露您的个人信息：\n      "
        )
      ]),
      _vm._v(" "),
      _c("dt", { staticClass: "bold" }, [_vm._v("一、共享")]),
      _vm._v(" "),
      _c("dd", { staticClass: "item" }, [
        _vm._v(
          "\n        我们不会与给缘服务提供者以外的公司、组织和个人共享您的个人信息，但以下情况除外：\n        "
        ),
        _c("p", [
          _vm._v(
            "\n          1、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。\n        "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n          2、在法定情形下的共享：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。\n        "
          )
        ]),
        _vm._v(" "),
        _vm._m(13),
        _vm._v(" "),
        _vm._m(14),
        _vm._v(" "),
        _vm._m(15),
        _vm._v(" "),
        _c("table", [
          _vm._m(16),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.DeviceData, function(item) {
              return _c("tr", { key: item.seq }, [
                _c("td", [_vm._v(_vm._s(item.seq))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(item.third))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(item.info))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(item.purpose))]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "a",
                    { staticClass: "blue", attrs: { href: item.agreement } },
                    [_vm._v(_vm._s(item.agreement))]
                  )
                ])
              ])
            }),
            0
          )
        ])
      ]),
      _vm._v(" "),
      _c("dt", { staticClass: "bold" }, [_vm._v("二、转让")]),
      _vm._v(" "),
      _vm._m(17),
      _vm._v(" "),
      _c("dt", { staticClass: "bold" }, [_vm._v("三、公开披露")]),
      _vm._v(" "),
      _vm._m(18),
      _vm._v(" "),
      _c("dt", { staticClass: "bold item" }, [
        _vm._v(
          "\n        四、共享、转让、公开披露个人信息时事先征得授权同意的例外\n      "
        )
      ]),
      _vm._v(" "),
      _vm._m(19),
      _vm._v(" "),
      _c("dt", { staticClass: "item bold" }, [
        _vm._v(
          "\n        根据法律规定，若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，则此类处理后数据的共享、转让、公开披露无需另行向您通知并征得您的同意。\n      "
        )
      ]),
      _vm._v(" "),
      _c("dt", { staticClass: "topTitle" }, [
        _vm._v("第四章节 我们如何保护您的个人信息")
      ]),
      _vm._v(" "),
      _vm._m(20),
      _vm._v(" "),
      _c("dt", { staticClass: "topTitle" }, [
        _vm._v("第五章节 我们使用Cookie技术的目的及方式")
      ]),
      _vm._v(" "),
      _c("dd", [
        _vm._v(
          "\n        一、为确保网站正常运转、为您获得更轻松的访问体验，我们会在计算机或移动设备上存储名为Cookie的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。Cookie是一种网络服务器存储在计算机或移动设备上的纯文本文件。Cookie的内容只能由创建它的服务器检索或读取\n      "
        )
      ]),
      _vm._v(" "),
      _c("dd", [
        _vm._v(
          "\n        二、我们Cookie的目的与大多数网站或互联网服务提供商启用Cookie的目的一样，即改善用户体验，我们不会将Cookie用于本隐私政策所述目的之外的任何用途。借助于Cookie，网站能够记住用户的单次访问或多次访问。借助于Cookie，网站能够保存设置，例如计算机或移动设备的语言、字体大小和其他浏览偏好。\n      "
        )
      ]),
      _vm._v(" "),
      _c("dd", { staticClass: "item" }, [
        _vm._v(
          "\n        三、您可根据自己的偏好管理或删除Cookie。您可以清除计算机上保存的所有Cookie，大部分网络浏览器都设有阻止Cookie的功能。但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置。\n      "
        )
      ]),
      _vm._v(" "),
      _c("dt", { staticClass: "topTitle" }, [
        _vm._v("第六章节 您如何管理您的个人信息")
      ]),
      _vm._v(" "),
      _vm._m(21),
      _vm._v(" "),
      _c("dt", { staticClass: "topTitle" }, [
        _vm._v("第七章节 我们如何处理未成年人的个人信息")
      ]),
      _vm._v(" "),
      _c("dd", { staticClass: "item" }, [
        _vm._v(
          "\n        任何18岁以下的未成年人均不得创建自己的用户账户及/或使用我们的服务。我们只会在法律法规允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或披露未成年人的个人信息。\n      "
        )
      ]),
      _vm._v(" "),
      _c("dt", { staticClass: "topTitle" }, [
        _vm._v("第八章节 本隐私政策如何更新")
      ]),
      _vm._v(" "),
      _vm._m(22),
      _vm._v(" "),
      _c("dt", { staticClass: "topTitle" }, [_vm._v("第九章节 如何联系我们")]),
      _vm._v(" "),
      _vm._m(23)
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "ac pd10" }, [_vm._v("大连亿果网络科技有限公司")]),
    _vm._v(" "),
    _c("p", { staticClass: "ac" }, [_vm._v("2022年11月02日")])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "title item" }, [
      _c("strong", [_vm._v("隐私政策")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("b", [_vm._v("【特别提示】")]),
      _vm._v(
        "还请您在使用给缘前，仔细阅读（未成年人请在监护人陪同下阅读）并了解本政策，以做出适当选择。当您同意本隐私政策时，即表示您已同意我们按照本政策处理您的相关信息。如果您不同意本隐私政策，您可以放弃使用我们的产品或服务。\n    "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dd", [
      _vm._v(
        "\n        本隐私政策中涉及的个人信息指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。本隐私政策中主要涉及的个人信息包括："
      ),
      _c("b", [
        _vm._v(
          "基本信息（包括个人姓名、生日、性别、住址、个人电话号码、电子邮箱）；个人身份信息（包括身份证、军官证、护照、驾驶证）；个人形象，声音和画面；网络身份标识信息（包括系统账号、密码、IP地址）；个人财产信息（交易和消费记录以及音符之类虚拟财产信息）；通讯录；个人常用设备信息（包括硬件型号、设备MAC地址、操作系统类型、软件列表、唯一设备识别码（包括IMEI/Android\n        ID/IDFA/OPENUDID/GUID、SIM卡IMSI信息在内的描述个人常用设备基本情况的信息）；个人位置信息（定位信息）"
        )
      ]),
      _vm._v("。\n      ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { colspan: "5" } }, [
          _vm._v("收集个人信息的业务功能")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", [_vm._v("序号")]),
      _vm._v(" "),
      _c("td", [_vm._v("业务功能")]),
      _vm._v(" "),
      _c("td", [_vm._v("所涉个人信息/系统权限类型")]),
      _vm._v(" "),
      _c("td", [_vm._v("收集使用目的")]),
      _vm._v(" "),
      _c("td", [_vm._v("收集方式")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dd", [
      _vm._v(
        "\n        2.运营与安全运行：我们致力于为你提供安全、可信的产品与使用环境，提供优质而可靠的服务与信息是我们的核心目标。"
      ),
      _c("b", [
        _vm._v(
          "为了维护相关产品或服务的正常稳定运行，保护你或其他用户或公众的安全及合法利益，我们会收集如下必要信息："
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dd", [
      _c("p", { staticClass: "para" }, [
        _vm._v(
          "1.为了保障软件与服务的安全运行、运营的质量及效率，我们会收集你的"
        ),
        _c("b"),
        _vm._v(
          "硬件型号、操作系统版本号、设备标识符（Android如IMEI、AndroidID、OAID、IMSI、ICCID、GAID、MEID，iOS如IDFV、IDFA；不同的标识符在有效期、是否可由用户重置以及获取方式方面会有所不同）、网络设备硬件地址（MAC地址）、硬件序列号、IP 地址、WLAN接入点（如SSID，BSSID）、蓝牙（Bluetooth）、基站、软件版本号、网络接入方式、类型、状态、网络质量数据、操作、使用、服务日志、传感器信息等数据。"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "para" }, [
        _vm._v(
          "2.为了预防恶意程序、保障运营质量及效率，我们会收集安装的应用信息或正在运行的进程信息、应用程序的总体运行、使用情况与频率、应用崩溃情况、总体安装使用情况、性能数据、应用来源。以及对平台进行优化升级，我们将收集应用软件运行异常信息。"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "para" }, [
        _vm._v(
          "3.为实现运行故障报错及分析和解决您在使用软件过程中所遇到的问题，"
        ),
        _c("b", [
          _vm._v(
            "我们将收集您的设备信息（GUID、MAC、IP地址）、浏览和操作记录。"
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "para" }, [
        _vm._v(
          "4.为了在服务过程中防止欺诈及保护您的交易安全，我们将收集您的设备位置信息。"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "para" }, [
        _vm._v(
          "5.我们可能使用你的帐号信息、设备信息、服务日志信息，以及我们的关联方、合作方获得你授权或依法可以提供给我们的信息，如：我们会用到SDK（com.umeng、数美设备指纹等）获取 "
        ),
        _c("b", [_vm._v("设备序列号")]),
        _vm._v(
          "，用于判断帐号安全、交易安全、进行身份验证、识别违法违规情况、检测及防范安全事件，并依法采取必要的记录、分析、处置措施。"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dd", [
      _vm._v(
        "\n        您可以使用第三方账号（如微信、QQ）登录给缘平台，此时您将授权我们获取您在第三方平台上的"
      ),
      _c("b", [_vm._v("公开信息")]),
      _vm._v(
        "（头像、昵称），并将您的该第三方账号与您的给缘账号绑定，使您可以通过该第三方账号直接登录并使用给缘的产品与服务。完成注册后，您将能够以注册用户身份在给缘平台上使用观看直播、留言评论等功能。为了给您提供更好的服务，并为了预防互联网犯罪，我们的关联公司、合作伙伴可能会（在有法律依据或征得您同意的前提下）向我们分享您的个人信息。我们可能从第三方获取您授权共享的账号信息（头像、昵称），并在您同意本隐私政策后将您的第三方账号与您的账号绑定，使您可以通过第三方账号直接登录并使用我们的产品或服务。我们会将依据与第三方的约定、对个人信息来源的合法性进行确认后，在符合相关法律和法规规定的前提下，使用您的这些个人信息。\n      "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dd", [
      _c("b", [
        _vm._v(
          "您也可以通过您设备的操作系统提供的选项来开启或关闭某些系统权限，从而允许或阻止我们收集您的个人信息，例如 "
        ),
        _c("b", [
          _vm._v("电话、联系人、麦克风、摄像头、内／外部存储空间访问权限。")
        ]),
        _vm._v(
          "请您注意，您开启这些权限即代表您授权我们可以收集和使用这些个人信息来实现相对应的功能，您关闭权限即代表您取消了这些授权，则我们将不再继续收集和使用您的这些个人信息，也无法为您提供上述与这些授权所对应的功能，但不影响您使用其他功能"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dd", [
      _vm._v(
        "\n        若您拒绝向我们提供某些个人信息，给缘APP整体仍然可用，但可能导致您无法正常使用某些功能，具体来说可能造成如下影响：\n        "
      ),
      _c("p", { staticClass: "para" }, [
        _vm._v(
          "\n          1.若您拒绝授权电话权限，我们将无法取得您的IMEI等唯一设备识别码，可能无法判定是否存在非法登录（盗号）、自动控制等情形，无法确保保障您的网络与信息安全；\n        "
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "para" }, [
        _vm._v(
          "\n          2.若您拒绝提供您的地理位置信息，会影响我们对您所处位置的判定，从而影响“附近”等与地理位置有关的功能实现；\n        "
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "para" }, [
        _vm._v(
          "\n          3.若您拒绝提供银行账号信息和个人身份证件信息，会导致无法完成消费、提现或其他交易；\n        "
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "para" }, [
        _vm._v(
          "\n          4.若您拒绝提供手机号码、个人身份证件信息和／或生物识别信息（面部特征），会导致我们无法进行实名认证，按照可适用的法律法规，您将不能使用直播开播功能，以及可能无法正常使用内容发布、分享方面的功能。征得授权同意的例外。\n        "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dd", { staticClass: "item bold" }, [
      _c("p", { staticClass: "para" }, [
        _vm._v(
          "\n          1、我们会根据本隐私政策的约定并为实现我们的产品与或服务功能对所收集的个人信息进行使用。\n        "
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "para" }, [
        _vm._v(
          "\n          2、在收集您的个人信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。\n        "
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "para" }, [
        _vm._v(
          "\n          3、请您注意，您在使用我们的产品与或服务时所提供的所有个人信息，除非您删除或通过系统设置拒绝我们收集，否则将在您使用我们的产品或服务期间持续授权我们使用。在您注销账号时，我们将停止使用并删除或匿名化处理您的个人信息。\n        "
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "para" }, [
        _vm._v(
          "\n          4、我们会对我们的产品与服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们的产品与服务的整体使用趋势。但这些统计信息将不包含您的任何个人信息。\n        "
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "para" }, [
        _vm._v(
          "\n          5、我们会采用包括内容替换、匿名处理方式对您的信息进行脱敏，以保护您的信息安全。\n        "
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "para" }, [
        _vm._v(
          "\n          6、当我们要将您的个人信息用于本政策未载明的其它用途时，或基于特定目的收集而来的信息用于其他目的时，会通过您主动做出勾选的形式事先征求您的同意，未经您的同意我们将不会使用。\n        "
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "para" }, [
        _vm._v(
          "\n          7、如我们停止运营给缘产品或服务，我们将及时停止继续收集您个人信息的活动，我们将停止运营的通知以逐一送达或公告的形式通知您，我们将停止使用并删除或匿名化处理您的个人信息。\n        "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dd", { staticClass: "bold" }, [
      _vm._v(
        "\n        一般而言，我们自您使用服务时获取到您个人信息之日起至您注销账户后"
      ),
      _c("b", [_vm._v("6个月内")]),
      _vm._v("会存储并保留您的个人信息。\n      ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dd", { staticClass: "bold" }, [
      _vm._v("\n        在您的个人信息超出保留期间后，"),
      _c("b", [
        _vm._v("我们会根据适用法律的要求删除您的个人信息，或使其匿名化处理。")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("\n          3、与授权合作伙伴共享："),
      _c("b", [
        _vm._v("我们可能委托授权合作伙伴为您提供某些服务或代表我们履行职能")
      ]),
      _vm._v(
        "，我们仅会出于本隐私权政策声明的合法、正当、必要、特定、明确的目的共享您的信息，授权合作伙伴只能接触到其履行职责所需信息，且不得将此信息用于其他任何目的。\n        "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("\n          目前，我们的授权合作伙伴包括以下类型："),
      _c("br"),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "（1）广告、分析服务类的授权合作伙伴。除非得到您的许可，否则我们不会将您的个人身份信息与提供广告、分析服务的合作伙伴共享。我们会委托这些合作伙伴处理与广告覆盖面和有效性相关的信息，但不会提供您的个人身份信息，或者我们将这些信息进行去标识化处理，以便它不会识别您个人。这类合作伙伴可能将上述信息与他们合法获取的其他数据相结合，以执行我们委托的广告服务或决策建议"
        )
      ]),
      _c("br"),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "（2）供应商、服务提供商和其他合作伙伴。我们将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供技术基础设施服务、分析我们服务的使用方式、衡量广告和服务的有效性、提供客户服务、支付便利或进行学术研究和调查。"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "item" }, [
      _vm._v(
        "\n          4、为了使您能够正常使用服务及功能，我们的应用中会接入第三方SDK,\n          "
      ),
      _vm._v(" "),
      _vm._v(
        "\n          我们会对授权合作伙伴获取有关信息的应用程序接口（API）、软件工具开发包（SDK）进行严格的安全检测，并与授权合作伙伴约定严格的数据保护措施，令其按照我们的委托目的、服务说明、本隐私权政策以及其他任何相关的保密和安全措施来处理个人信息。"
      ),
      _c("br")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "width20" }, [_vm._v("序号")]),
        _vm._v(" "),
        _c("th", [_vm._v("第三方")]),
        _vm._v(" "),
        _c("th", [_vm._v("所涉信息")]),
        _vm._v(" "),
        _c("th", [_vm._v("用途")]),
        _vm._v(" "),
        _c("th", [_vm._v("第三方隐私协议政策")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dd", [
      _vm._v(
        "\n        我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外："
      ),
      _c("br"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n          1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；\n        "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n          2、在涉及合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。\n        "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dd", [
      _vm._v("\n        我们仅会在以下情况下，公开披露您的个人信息："),
      _c("br"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n          1、获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；\n        "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n          2、如果我们确定您出现违反法律法规或严重违反给缘相关协议规则的情况，或为保护给缘及其关联公司用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或给缘相关协议规则征得您同意的情况下披露关于您的个人信息，包括相关违规行为以及给缘已对您采取的措施。\n        "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dd", { staticClass: "item" }, [
      _vm._v(
        "\n        以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意："
      ),
      _c("br"),
      _vm._v(" "),
      _c("p", [_vm._v("1、与国家安全、国防安全有关的；")]),
      _vm._v(" "),
      _c("p", [_vm._v("2、与公共安全、公共卫生、重大公共利益有关的；")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n          3、与犯罪侦查、起诉、审判和判决执行等司法或行政执法有关的；\n        "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n          4、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；\n        "
        )
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("5、您自行向社会公众公开的个人信息；")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n          6、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；\n        "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n          7、学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；\n        "
        )
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("8、法律法规规定的其他情形。")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dd", { staticClass: "item" }, [
      _vm._v(
        "\n        我们非常重视您个人信息的安全，将努力采取合理的安全措施（包括技术方面和管理方面）来保护您的个人信息，防止您提供的个人信息被不当使用。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n          一、我们会使用不低于同行的加密技术、匿名化处理及相关合理可行的手段保护您的个人信息，并使用安全保护机制防止您的个人信息遭到恶意攻击。\n        "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n          二、我们会采取合理可行的措施，尽力避免收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。\n        "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n          三、给缘平台上提供的直播和其他业务功能中某些具体的模块或功能由外部供应商提供。对我们委托处理个人信息的公司、组织和个人，我们会与其签署严格的保密协议，要求他们按照我们的要求、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。\n        "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("\n          四、互联网并非绝对安全的环境，"),
        _c("b", [
          _vm._v("我们强烈建议您不要使用非给缘推荐的通信方式发送个人信息。")
        ]),
        _vm._v(
          "您可以通过我们的服务建立联系和相互分享。当您通过我们的服务创建交流、交易或分享时，您可以自主选择沟通、交易或分享的对象，作为能够看到您的交易内容、联络方式、交流信息或分享内容等相关信息的第三方。\n        "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dd", { staticClass: "item" }, [
      _vm._v(
        "\n        您应确保提交的所有个人数据都准确无误，并及时更新这些数据。您可以通过以下方式访问及管理您的个人信息："
      ),
      _c("br"),
      _vm._v(" "),
      _c("p", [
        _c("b", [_vm._v("一、查询您的个人信息")]),
        _c("br"),
        _vm._v(
          "\n          您有权访问您的个人信息，法律法规规定的例外情况除外。您可以通过以下方式自行访问您的个人信息："
        ),
        _c("br"),
        _vm._v(
          "\n          个人信息—如果您希望访问或编辑您个人资料中的昵称、头像、性别以及其他资料的，您可以通过登录账户通过“我的”-“头像”执行此类操作。\n        "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _c("b", [_vm._v("二、更正您的个人信息")]),
        _c("br"),
        _vm._v(
          "\n          当您发现关于您的个人信息有错误时，您有权要求我们做出更正或补充。您可以通过本章节“一”访问查询您的“个人信息”中列明的方式提出更正或补充申请。\n        "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _c("b", [_vm._v("三、删除您的个人信息")]),
        _c("br"),
        _vm._v(
          "\n          您可以通过本章节“一”访问查询您的“个人信息”中列明的方式删除您的部分个人信息。在以下情形中，您可以向我们提出删除个人信息的请求："
        ),
        _c("br"),
        _vm._v("\n          1、如果我们处理个人信息的行为违反法律法规；"),
        _c("br"),
        _vm._v(
          "\n          2、如果我们收集、使用您的个人信息，却未征得您的明确同意；"
        ),
        _c("br"),
        _vm._v(
          "\n          3、如果我们处理个人信息的行为严重违反了与您的约定；"
        ),
        _c("br"),
        _vm._v(
          "\n          4、如果您不再使用我们的产品或服务，或您主动注销了账号；"
        ),
        _c("br"),
        _vm._v("\n          5、如果我们永久不再为您提供产品或服务。"),
        _c("br"),
        _vm._v(" "),
        _c("b", [
          _vm._v(
            "\n            当您或我们协助您从我们的服务中删除信息后，依据相关法律法规的规定，我们可能不会立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并将其与任何进一步处理隔离，直到备份可以清除或实现匿名。\n          "
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _c("b", [_vm._v("四、个人信息主体注销账户")]),
        _c("br"),
        _vm._v(
          "\n          您可以通过以下方式注销自己的账号：\n          1.登录给缘手机客户端，进入“我的”→“设置”→“注销账号”；\n          2.按照本政策文末所列明的公开联系方式，联系我们客服微信号："
        ),
        _c("span", { staticClass: "blue" }, [_vm._v("d17172154717")]),
        _vm._v(
          ";协助您注销账号。\n          在您主动注销账户之后，我们将停止为您提供产品或服务，根据适用法律的要求删除您的个人信息，或使其匿名化处理。\n        "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _c("b", [_vm._v("五、用户授权撤回")]),
        _c("br"),
        _vm._v("\n          您可以通过以下途径撤销已同意的授权："),
        _c("br"),
        _vm._v("\n          1、发送邮件至 "),
        _c(
          "a",
          {
            staticClass: "blue",
            attrs: { href: "milto:shouqingkefu@requjiaoyou.com" }
          },
          [_vm._v("shouqingkefu@requjiaoyou.com ")]
        ),
        _c("br"),
        _vm._v(
          "\n          您申请授权撤回后，给缘将不再处理相应的个人信息。请您理解，因您的授权撤回，我们无法继续为您提供撤回同意或授权所对应的特定功能或/和服务。但您撤回同意的决定，不会影响此前基于您的授权而展开的个人信息处理。\n        "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _c("b", [_vm._v("六、通过客服响应您的上述请求")]),
        _c("br"),
        _vm._v(
          "\n          在您无法自行通过账户密码进行操作的情况下，为保障个人信息安全，我们可能会先要求您验证自己的身份，然后再处理您的请求。您可能需要提供书面请求，或以其他方式证明您的身份。\n          针对此类请求，我们将在15天个工作日内做出答复。\n        "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _c("b", [
          _vm._v("七、在以下情形中，按照法律法规要求，我们将无法响应您的请求")
        ]),
        _c("br"),
        _vm._v("\n          1、与国家安全、国防安全有关的；"),
        _c("br"),
        _vm._v("\n          2、与公共安全、公共卫生、重大公共利益有关的；"),
        _c("br"),
        _vm._v("\n          3、与犯罪侦查、起诉、审判和执行判决等有关的；"),
        _c("br"),
        _vm._v(
          "\n          4、响应您的请求将使其他个人、组织的合法权益受到严重损害的；"
        ),
        _c("br")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dd", { staticClass: "item" }, [
      _vm._v("\n        我们的隐私权政策可能变更。"),
      _c("br"),
      _vm._v(
        "\n        未经您明确同意，我们不会限制您按照本隐私权政策所应享有的权利。对于重大变更，我们会提供显著的通知（包括我们会通过给缘公示的方式进行通知甚至向您提供弹窗提示）。"
      ),
      _c("br"),
      _vm._v("\n        本政策所指的重大变更包括但不限于："),
      _c("br"),
      _vm._v(
        "\n        1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；"
      ),
      _c("br"),
      _vm._v(
        "\n        2、我们在控制权等方面发生重大变化。如并购重组等引起的所有者变更等；"
      ),
      _c("br"),
      _vm._v("\n        3、个人信息共享、转让或公开披露的主要对象发生变化；"),
      _c("br"),
      _vm._v(
        "\n        4、您参与个人信息处理方面的权利及其行使方式发生重大变化；"
      ),
      _c("br"),
      _vm._v(
        "\n        5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；"
      ),
      _c("br"),
      _vm._v("\n        6、个人信息安全影响评估报告表明存在高风险时。"),
      _c("br"),
      _vm._v("\n        我们还会将本隐私权政策的旧版本存档，供您查阅。\n      ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dd", [
      _vm._v(
        "\n        您可以通过以下方式与我们联系，我们将在15个工作日内回复您的请求："
      ),
      _c("br"),
      _vm._v(
        "\n        1、如果您对本政策内容有任何疑问、意见或建议，您可通过给缘客服微信号,"
      ),
      _c("span", { staticClass: "blue" }, [_vm._v("d17172154717")]),
      _vm._v(";"),
      _c("br"),
      _vm._v("\n        2、如发现个人信息可能被泄露，您可以发邮件至"),
      _c(
        "a",
        {
          staticClass: "blue",
          attrs: { href: "mailto:shouqingkefu@requjiaoyou.com" }
        },
        [_vm._v("shouqingkefu@requjiaoyou.com")]
      ),
      _vm._v("投诉举报。"),
      _c("br"),
      _vm._v(
        "\n        3、本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国法律。因本协议产生之争议，均应依照中华人民共和国法律予以处理。"
      ),
      _c("br"),
      _vm._v(
        "\n        4、如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，"
      ),
      _c("b", [
        _vm._v(
          "您还可以通过向被告住所地有管辖权的法院通过起诉途径寻求解决方案。"
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-515f0221", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-515f0221","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/privacy.vue
// module id = null
// module chunks = 